import { Styles } from 'jss';

import { imageStyles } from './image.styles';
import { linkStyles } from './link.styles';
import { videoStyles } from './video.styles';
import { CreativeTypeEnum } from '../../dto/recs.dto';
import { StylesDataType } from '../../types';

export const styles: Record<CreativeTypeEnum, Styles<string, StylesDataType>> = {
  [CreativeTypeEnum.LINK]: linkStyles,
  [CreativeTypeEnum.IMAGE]: imageStyles,
  [CreativeTypeEnum.VIDEO]: videoStyles,
};
